import React from 'react';
import ContentLoader from 'react-content-loader';
import PanelContainer from './../PanelContainer';

const FiltersContentLoader = props => (
  <PanelContainer styles={{ padding: '20px 30px' }}>
    <ContentLoader
      height={700}
      width={298}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      {...props}
    >
      <rect x="3" y="1" rx="0" ry="0" width="100%" height="55" />
      <rect x="3" y="92" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="132" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="172" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="212" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="252" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="292" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="332" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="372" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="412" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="452" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="492" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="532" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="572" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="612" rx="0" ry="0" width="100%" height="15" />
      <rect x="3" y="652" rx="0" ry="0" width="100%" height="15" />
    </ContentLoader>
  </PanelContainer>
);

export default FiltersContentLoader;
